// Registro de ids escritos localmente há pouco.
// Serve para o store IGNORAR o "eco" do realtime do PRÓPRIO cliente: como a
// edição já foi aplicada localmente (otimista), reprocessar o eco só causaria
// um re-render desnecessário que tira o foco do campo em edição.
const recent = new Map() // id -> timestamp (ms)
const JANELA_MS = 6000

export function markWrite(id) {
  if (id) recent.set(id, Date.now())
}

export function wasRecent(id) {
  if (!id) return false
  const t = recent.get(id)
  if (t == null) return false
  if (Date.now() - t > JANELA_MS) {
    recent.delete(id)
    return false
  }
  return true
}
